// SearchSelectpicker
var SlugFromString = class SlugFromString {
  /*
  constructor
  */
  constructor (name) {
    this.name = name
  }
  /*
  getNick
  */
  getSlug (param) {
    var name = this.replaceAccents(this.name) // remove acentos
    name = name.toLowerCase()
    name = name.replace(/\./gi, ' ')
    name = name.replace(/^\s+|\s+$/gi, '').replace(/\s{2,}/gi, ' ') // remove espaços duplicados e trim
    name = name.replace(/[^a-z0-9 ]+/g, '')

    return name.replace(/ /gi, param.spage)
  }
  /*
  replaceAccents
  */
  replaceAccents (str) {
    var dict = {
      'á': 'a',
      'â': 'a',
      'à': 'a',
      'å': 'a',
      'ã': 'a',
      'ä': 'a',
      'é': 'e',
      'ê': 'e',
      'è': 'e',
      'ë': 'e',
      'í': 'i',
      'î': 'i',
      'ì': 'i',
      'ï': 'i',
      'ó': 'o',
      'ô': 'o',
      'ò': 'o',
      'ø': 'o',
      'õ': 'o',
      'ö': 'o',
      'ú': 'u',
      'û': 'u',
      'ù': 'u',
      'ü': 'u',
      'ç': 'c',
      'ñ': 'n'
    }
    return str.replace(/[^\w ]/g, function (char) { return dict[char] || char })
  }
}

export default SlugFromString



// WEBPACK FOOTER //
// ./src/utils/SlugFromString.js